import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

const ONBOARDING_TITLE = 'Votre demande est prête';
const ONBOARDING_DESCRIPTION = 'Nous avons préparé un prompt standard pour transcrire vos audios et en tirer une synthèse. Vous pouvez le modifier pour préciser le ton, le niveau de détail, le plan du compte rendu ou demander uniquement la transcription. Il ne reste qu’à joindre jusqu’à 5 fichiers audio.';
const ONBOARDING_PRIMARY_CTA = 'Choisir mes fichiers';
const ONBOARDING_SECONDARY_CTA = 'Modifier le prompt';

type AudioTranscriptionOnboardingDialogProps = {
  onChooseFiles: () => void;
  onEditPrompt: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
};

export function AudioTranscriptionOnboardingDialog({
  onChooseFiles,
  onEditPrompt,
  onOpenChange,
  open,
}: AudioTranscriptionOnboardingDialogProps) {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="sm:max-w-lg" data-testid="audio-transcription-onboarding">
        <DialogHeader>
          <DialogTitle>{ONBOARDING_TITLE}</DialogTitle>
          <DialogDescription>{ONBOARDING_DESCRIPTION}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:justify-end">
          <Button
            onClick={onEditPrompt}
            type="button"
            variant="outline"
          >
            {ONBOARDING_SECONDARY_CTA}
          </Button>
          <Button
            onClick={onChooseFiles}
            type="button"
          >
            {ONBOARDING_PRIMARY_CTA}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
